import styled from "@emotion/styled";

import { getManagerEmployeeStatusColor } from "manager/utils/employeeStatus";
import type { ManagerEmployeeStatusVariant } from "manager/utils/employeeStatus";

interface EmployeeStatusProps {
  variant: ManagerEmployeeStatusVariant;
}

export const EmployeeStatus = styled.span<EmployeeStatusProps>`
  color: ${({ variant }) => getManagerEmployeeStatusColor(variant)};
`;

export const EmployeeNameCell = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  width: 100%;
`;

export const EmployeeNameStrong = styled.strong`
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ManageEmployeesIconButton = styled.button`
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  margin-left: 6px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: default;
  color: #6c63ff;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid #6c63ff;
    outline-offset: 2px;
  }
`;
